import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyDiscountCustomerGetsProductIdKey,
  ShopifyDiscountCustomerGetsProductKey,
  ShopifyDiscountCustomerGetsProductToDiscountKey,
  ShopifyDiscountCustomerGetsProductToProductKey,
  ShopifyDiscountCustomerGetsProductToShopKey,
  ShopifyDiscountKey,
  ShopifyProductKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyDiscountCustomerGetsProductKey,
  "2023-07": {
    name: "Shopify Discount Customer Gets Product",
    fields: [
      {
        name: "ID",
        key: ShopifyDiscountCustomerGetsProductIdKey,
        fieldType: FieldType.ID,
      },
      {
        name: "Discount",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDiscountCustomerGetsProductToDiscountKey,
        configuration: {
          relatedModelKey: ShopifyDiscountKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "discountId",
            skipGraphQLSelection: true,
          },
        },
      },
      {
        name: "Product",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDiscountCustomerGetsProductToProductKey,
        configuration: {
          relatedModelKey: ShopifyProductKey,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "productId",
            skipGraphQLSelection: true,
          },
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDiscountCustomerGetsProductToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    // in somewhat of a gross an anti-pattern, because shopifyDiscount is already synced through
    // a complicated custom sync, we also sync this model as part of it
    // although note, that we also need to do this sync on discount webhooks since shopify doesn't
    // send the full discount object in the webhook; so the actual place where the syncing happens is
    // in ShopifyDiscountGraphQLHandler
    syncConfig: { type: "inherit" },
  },
};

export const ShopifyDiscountCustomerGetsProduct = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
